import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';

@Component({
  standalone: true,
  selector: 'app-budget-plan-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.scss'],
  imports: [
    CommonModule,
    MatCardModule,
    MatIconModule
  ]
})
export class BudgetPlanStatusComponent {

  @Input() totalCostsRequested!: number;           // sum of all "requested" from municipality
  @Input() totalCostsActual!: number;              // sum of all "actual" costs
  @Input() totalFundingFromOtherSources!: number;  // sum of all "other sources"

  /**
   * The difference is: totalCostsActual - (totalCostsRequested + totalFundingFromOtherSources).
   * 
   * If difference > 0 => They are short and need more funds
   * If difference < 0 => They have requested more than the actual cost
   * If difference = 0 => Perfectly in sync
   */
  get difference(): number {
    return this.totalCostsActual - (this.totalCostsRequested + this.totalFundingFromOtherSources);
  }

  /**
   * True if everything is perfectly balanced: difference = 0
   */
  get isBudgetPlanInSync(): boolean {
    return this.difference === 0;
  }

  /**
   * Convenience to see if we are short on funds
   */
  get isShort(): boolean {
    return this.difference > 0;
  }

  /**
   * Convenience to see if we've overshot the actual cost
   */
  get isOver(): boolean {
    return this.difference < 0;
  }
}